import React, { useState, useEffect } from 'react';
import { Card, Typography } from '@mui/material';
import VuiBox from 'components/VuiBox';
import { getMonthlyTokenUsage } from 'utils/requests/dify';
import showToast from 'components/Toast/Toast';

const TokenCounter = ({ sx = {} }) => {
  const [tokenData, setTokenData] = useState({
    tokensUsed: 0,
    tokensLimit: 200000,
    lastReset: null,
    isLoading: true,
  });

  useEffect(() => {
    loadTokenData();
  }, []);

  const loadTokenData = async () => {
    try {
      setTokenData(prev => ({ ...prev, isLoading: true }));
      
      const tokensUsed = await getMonthlyTokenUsage();
      
      if (typeof tokensUsed === 'number' && tokensUsed >= 0 && !isNaN(tokensUsed)) {
        setTokenData({
          tokensUsed: tokensUsed,
          tokensLimit: 200000,
          lastReset: null,
          isLoading: false,
        });
      } else {
        throw new Error('Dados inválidos retornados pela API');
      }
    } catch (error) {
      console.error('Erro ao carregar dados de tokens:', error);
      
      setTokenData({
        tokensUsed: 0,
        tokensLimit: 200000,
        lastReset: null,
        isLoading: false,
      });
      
      showToast('Erro ao carregar dados de tokens. Tente novamente mais tarde.', 'error');
    }
  };

  const getProgressPercentage = () => {
    const percentage = Math.min((tokenData.tokensUsed / tokenData.tokensLimit) * 100, 100);
    return percentage;
  };

  const getProgressColor = () => {
    return '#FC6508';
  };

  const formatNumber = (num) => {
    return num.toLocaleString('pt-BR');
  };

  const getNextResetDate = () => {
    const today = new Date();
    const nextMonth = new Date(today.getFullYear(), today.getMonth() + 1, 1);
    return nextMonth.toLocaleDateString('pt-BR', {
      day: 'numeric',
      month: 'short',
      year: 'numeric'
    });
  };

  if (tokenData.isLoading) {
    return (
      <Card sx={{ 
        height: "100%", 
        py: "32px", 
        padding: "25px 22px",
        backgroundColor: '#0F1535',
        border: '1px solid rgba(255, 255, 255, 0.1)',
        ...sx 
      }}>
        <VuiBox display="flex" flexDirection="column" alignItems="center" justifyContent="center" height="200px">
          <Typography variant="body2" sx={{ color: 'rgba(255, 255, 255, 0.6)' }}>
            Carregando dados de tokens...
          </Typography>
        </VuiBox>
      </Card>
    );
  }

  return (
    <Card sx={{ 
      height: "100%", 
      width: "540px",
      backgroundColor: '#0F1535',
      border: '1px solid rgba(255, 255, 255, 0.1)',
      borderRadius: "5px",
      ...sx 
    }}>
      <VuiBox display="flex" flexDirection="column" height="100%">
        <VuiBox flex={1} display="flex" flexDirection="column" justifyContent="center">
          <VuiBox display="flex" alignItems="baseline" gap={1} mb={1}>
            <Typography 
              variant="h2" 
              sx={{ 
                color: '#FFFFFF', 
                fontWeight: 'bold', 
                fontSize: '20px',
                lineHeight: 1
              }}
            >
              {formatNumber(tokenData.tokensUsed)}
            </Typography>
            <Typography 
              variant="body1"
              sx={{ 
                color: 'rgba(255, 255, 255, 0.6)', 
                fontSize: '14px'
              }}
            >
              / {formatNumber(tokenData.tokensLimit)}
            </Typography>
          </VuiBox>
          <VuiBox mb={1}>
            <VuiBox
              sx={{
                width: '100%',
                height: 8,
                backgroundColor: 'rgba(255, 255, 255, 0.1)',
                borderRadius: "5px",
                overflow: 'hidden',
                position: 'relative'
              }}
            >
              <VuiBox
                sx={{
                  width: `${getProgressPercentage()}%`,
                  height: '100%',
                  backgroundColor: getProgressColor(),
                  borderRadius: "5px",
                  transition: 'width 0.3s ease'
                }}
              />
            </VuiBox>
          </VuiBox>
          <Typography 
            variant="body1" 
            sx={{ 
              color: '#FFFFFF', 
              fontSize: '14px',
              fontWeight: 'medium',
              mb: 2
            }}
          >
            Tokens
          </Typography>
          <VuiBox>
            <Typography 
              variant="body2" 
              sx={{ 
                color: 'rgba(255, 255, 255, 0.8)', 
                fontSize: '10px',
              }}
            >
              200k inclusas.
            </Typography>
            <Typography 
              variant="body2" 
              sx={{ 
                color: 'rgba(255, 255, 255, 0.6)', 
                fontSize: '10px'
              }}
            >
              Próximo reset: {getNextResetDate()}
            </Typography>
          </VuiBox>
        </VuiBox>
      </VuiBox>
    </Card>
  );
};

export default TokenCounter; 